import { observable } from 'mobx'
import { ResourcesRequest } from './ResourcesRequest'

class ResourcesStore {
  @observable items = []
  @observable shareList = []
  @observable breadCrumb = []
  @observable currentFolderId = ''
  @observable isLoading = false
  @observable keyword = null
  @observable typeTab = 'TCD'
  @observable currentPage = 0
  @observable pageSize = 10
  @observable title = null
  @observable authorityIssuedName = null
  @observable internalDocumentType = null

  // Không cần observable, chỉ dùng nội bộ để chống race condition
  _requestId = 0

  search = async () => {
    this.isLoading = true
    const requestId = ++this._requestId

    try {
      const params = {
        typeTab: this.typeTab,
        page: this.currentPage,
        size: this.pageSize,
      }
      if (this.currentFolderId) params.id = this.currentFolderId
      if (this.keyword) params.keyword = this.keyword
      if (this.title) params.docTitle = this.title
      if (this.authorityIssuedName)
        params.docAuthorityName = this.authorityIssuedName
      if (this.internalDocumentType) params.docType = this.internalDocumentType

      const response = await ResourcesRequest.search(params)

      // Nếu trong lúc chờ API, đã có lần gọi search() khác mới hơn
      // (ví dụ do đổi tab nhanh) thì bỏ qua kết quả trả về trễ này
      if (requestId !== this._requestId) return

      this.items = response.data?.data || []
      this.breadCrumb = response.data?.breadcrumb || []
    } catch (e) {
      console.error('Search error:', e)
      throw e
    } finally {
      if (requestId === this._requestId) this.isLoading = false
    }
  }

  searchShareList = async () => {
    try {
      const response = await ResourcesRequest.shareList({
        keyword: this.keyword || '',
      })
      this.shareList = response.data?.data || []
    } catch (e) {
      console.error('Share list search error:', e)
      throw e
    }
  }

  delete = async id => {
    this.isLoading = true
    try {
      await ResourcesRequest.delete(id)
      await this.search()
    } finally {
      this.isLoading = false
    }
  }

  published = async data => {
    this.isLoading = true
    try {
      await ResourcesRequest.published(data)
      await this.search()
    } finally {
      this.isLoading = false
    }
  }

  clear = () => {
    this.items = []
    this.breadCrumb = []
    this.currentFolderId = ''
    this.isLoading = false
    this.keyword = null
    this.title = null
    this.authorityIssuedName = null
    this.internalDocumentType = null
    this.currentPage = 0
  }

  // Đổi tab: phải reset toàn bộ dữ liệu + filter của tab cũ,
  // tránh việc dữ liệu/filter cũ "rò" sang tab mới
  setTypeTab = typeTab => {
    this.typeTab = typeTab || 'TCD'
    this.currentPage = 0
    this.items = []
    this.breadCrumb = []
    this.currentFolderId = ''
    this.keyword = null
    this.title = null
    this.authorityIssuedName = null
    this.internalDocumentType = null
  }

  clearShareList = () => {
    this.shareList = []
  }

  resetPagination = () => {
    this.currentPage = 0
  }
}

export default new ResourcesStore()
